// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3td8K","visuallyhidden":"_3XXLM","hide-text":"_3wtOb","center":"_1oIav","noprint":"waLIM","innerContainer":"_1cz6w","mastheadExtension":"_37995","mastheadExtension-isOpen":"_2QsPC _37995"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/MastheadExtension.scss
 ** module id = 460
 ** module chunks = 0
 **/